<div class="text-center mb-6">
  <h1 class="mb-2 text-3xl font-bold">{{ titles.title }}</h1>
  <h3 class="text-xl font-medium text-gray-600">{{ titles.subtitle }}</h3>
</div>
